/**
 * The api should follow backend api's rule
 * Example: /exchange-api/v1/private/mbxgateway/[user-stream]/start
 * We name the action like user-stream, the end path of api
 * actionName: userStream, and group apis & action types
 *
 * If the parent's api is name like a service,
 * Example: /exchange-api/v1/public/[asset-service]/product/get-products
 * We name the it as a service assetService
 */

const GATE_WAY = 'gateway-api';

export default {
  // Asset service apis
  USER_TRADE_FEE_API_PATH: '/exchange-api/v1/public/asset-service/product/get-trade-fee',
  CURRENCY_RATE_API_PATH: '/exchange-api/v1/public/asset-service/product/currency',
  PRODUCTS_API_PATH: '/exchange-api/v1/public/asset-service/product/get-products',
  GET_USER_ASSET_API: '/exchange-api/v2/private/asset-service/asset/get-user-asset',
  GET_USER_BTC_VALUATION_API: '/exchange-api/v1/private/asset-service/asset/btc-valuation',
  FAVORITES_API_PATH: '/exchange-api/v1/private/asset-service/portfolio/get',
  DELETE_FAVORITE_DATA_API_PATH: '/exchange-api/v1/private/asset-service/portfolio/del',
  ADD_FAVORITE_DATA_API_PATH: '/exchange-api/v1/private/asset-service/portfolio/add',
  APPLY_WITHDRAW_API_PATH: '/assetWithdraw/applyWithdraw.html',
  WITHERAW_RESEND_EMAIL_API_PATH: '/gateway-api/v1/private/capital/withdraw/reSendMail',
  WITHERAW_CANCEL_API_PATH: '/gateway-api/v1/private/capital/withdraw/cancel',
  // Top Movers
  GET_KLINE_LIST: '/gateway-api/v1/public/asset-service/getTokenTopMoversSvg',

  // User stream apis
  START_STREAM_API_PATH: '/exchange-api/v1/private/mbxgateway/user-stream/start',
  USER_STREAM_PING_API: '/exchange-api/v1/private/mbxgateway/user-stream/ping',

  // Mbxgateway order apis
  ORDER_API_PATH: '/exchange-api/v1/private/mbxgateway/order/place',
  DELETE_ORDER_API_PATH: '/exchange-api/v1/private/mbxgateway/order/del',
  DELETE_ALL_ORDER_API_PATH: '/exchange-api/v1/private/mbxgateway/order/delall',
  OCO_ORDER_API_PATH: `/${GATE_WAY}/v1/private/mbxgateway/order/oco/place`,
  OPEN_ORDERS_API_PATH: '/exchange-api/v1/private/streamer/order/get-open-orders',
  TRADE_ORDERS_API_PATH: '/exchange-api/v1/private/streamer/order/get-trade-orders',
  USER_TRADES_API_PATH: '/exchange-api/v1/private/streamer/trade/get-user-trades',
  USER_TRADE_DETAIL_API_PATH: '/exchange-api/v1/private/streamer/trade/get-user-trade-detail',

  // Account apis
  USER_INFO_API_PATH: '/gateway-api/v1/private/account/user/base-detail',
  GET_KYC_VALIDATE_INFO_API: '/gateway-api/v1/private/account/user-kyc/get-kyc-validate-info',
  GET_CURRENT_KYC_VALIDATE_INFO_API: '/gateway-api/v1/private/account/user-kyc/current-kyc-status',
  USER_LOGS_API_PATH: '/gateway-api/v1/private/account/user/get-user-login-log',
  GET_USER_CONFIG_API: '/gateway-api/v1/private/account/user-config/get',
  GET_AGENT_ID_INFO: '/gateway-api/v1/public/account/agent-info/get',
  REGISTER_API_PATH: '/gateway-api/v1/public/account/user/register',
  RESEND_EMAIL_API_PATH: '/gateway-api/v1/public/account/user/resend-register-email',
  SEND_MOBILE_VERIFY_CODE_API: '/gateway-api/v1/protect/account/mobile/send-mobile-verify-code',
  BIND_MOBILE_API: '/gateway-api/v1/private/account/user/bind-mobile',
  SEND_BIND_MOBILE_VERIFY_CODE: '/gateway-api/v1/private/account/user/send-bind-mobile-verify-code',
  BIND_GOOGLE_VERIFY_API: '/gateway-api/v1/private/account/user/bind-google-verify',
  UNBIND_GOOGLE_VERIFY_API: '/gateway-api/v1/private/account/user/unbind-google-verify',
  UNBIND_MOBILE_API: '/gateway-api/v1/private/account/user/unbind-mobile',
  GENERATE_SECRET_KEY_API: '/gateway-api/v1/private/account/user/generate-secret-key',
  GET_COUNTRY_SHORT_NAME: '/gateway-api/v1/public/account/ip/country-short',
  OPEN_WITHDRAW_WHITE_STATUS_API_PATH:
    '/gateway-api/v1/private/account/user/open-withdraw-white-status',
  CLOSE_WITHDRAW_WHITE_STATUS_API_PATH:
    '/gateway-api/v1/private/account/user/close-withdraw-white-status',
  SAVE_USER_CONFIG_API_PATH: '/gateway-api/v1/private/account/user-config/save',
  ANTI_PHISHING_CODE_API_PATH: '/gateway-api/v1/private/account/user/get-anti-phishing-code',
  SET_ANTI_PHISHING_CODE_API_PATH: '/gateway-api/v1/private/account/user/set-anti-phishing-code',
  SEND_SMS_CODE_API_PATH: '/gateway-api/v1/protect/account/mobile/send-mobile-verify-code',
  SET_COMMISSION_STATUS_API_PATH: '/gateway-api/v1/private/account/user/set-commission-status',
  TRADE_LEVEL_API_PATH: '/gateway-api/v1/public/account/trade-level/get',
  TRADE_INFO_API_PATH: '/gateway-api/v1/private/account/trade-info/get',
  // USER_TOTAL_COMMISSION_API_PATH: '/gateway-api/v1/private/account/commission/total',
  USER_DEVICE_LIST_API_PATH: '/gateway-api/v1/private/account/user-device/page',
  DELETE_USER_DEVICE_API_PATH: '/gateway-api/v1/private/account/user-device/delete',
  FETCH_USER_DEVICE_LOG_API_PATH: '/gateway-api/v1/private/account/user-device/log/page',
  USER_UPDATE_PASSWORD_API: '/gateway-api/v1/private/account/user/update-password',
  FETCH_ACCOUNT_ACTIVITY_RECORD:
    '/gateway-api/v1/private/account/user-operation-log/last-7-days/query',
  DISABLE_ACCOUNT: '/gateway-api/v1/private/account/user/forbidden-by-oneself',
  CHECK_ACCOUNT_WITHDRAW_FACE_STATUS: '/gateway-api/v1/private/account/user/check/withdraw-face',
  CHECK_ACCOUNT_WITHDRAW_HISTORY_ADDRESS_STATUS:
    '/gateway-api/v1/private/account/user/check/withdraw-historyAddr',
  UPDATA_USER_BASE_INFO: '/gateway-api/v1/private/account/user-kyc/submit-base-info',
  FACE_INIT_API_PATH: '/gateway-api/v1/public/account/user-face/sdk-face-init',
  WEB_FACE_INIT_API_PATH: '/gateway-api/v1/public/account/user-face/web-face-init',
  UPDATA_COMPANY_BASE_INFO:
    '/gateway-api/v1/private/account/user-certificate/submit-company-certificate',
  UPDATA_FACE_VERIFY_STATUS: '/gateway-api/v1/public/account/user-face/face-is-passed',
  GET_COUNTRY_IP_RESTRICTED: '/gateway-api/v1/public/country/ip/restricted',
  // 获取KYC状态
  GET_KYC_STATUS_API: '/gateway-api/v1/private/account/kyc-certificate/get-new-kyc-status',
  // 获取sen状态
  CHECK_SILVERGATE_STATUS: '/gateway-api/v1/private/fiatpayment/userPaymethod/kycCheck',
  // 获取钱包状态
  ACCOUNT_DETAIL_URL: '/gateway-api/v1/private/fiatpayment/us/get-account-detail',
  FETCH_FILL_INFO_INFO: '/gateway-api/v1/private/account/kyc-certificate/get-fill-info',
  FETCH_US_STATES_INFO: '/gateway-api/v1/private/account/kyc-certificate/get-usstates-info',
  SUBMIT_USER_REFERRAL_SETTINGS: '/gateway-api/v1/private/account/user-referral-settings/submit',

  // Common apis
  ACQUIRE_HOLD_BNB_API: '/gateway-api/v1/public/common/config/bnb',
  USER_GAS_RATE_API_PATH: '/gateway-api/v1/public/common/config/get-by-name',
  GET_GEETEST_CODE_API_PATH: '/gateway-api/v1/public/common/security/gt-code',
  REF_SWITCH_API_PATH: '/gateway-api/v1/public/common/config/get-ref-switch',
  GET_REGISTER_OPEN_STATUS: '/gateway-api/v1/public/common/config/register-open-status',

  // Fiat payment apis
  GET_BANK_INFO_API: '/gateway-api/v1/private/fiatpayment/get-bank-info',
  APPLY_CHARGE_API_PATH: '/gateway-api/v1/private/fiatpayment/apply-charge',
  QUERY_BALANCE_API_PATH: '/gateway-api/v1/private/fiatpayment/query-balance',
  APPLY_WITHDRWA: '/gateway-api/v1/private/fiatpayment/apply-withdraw',
  BIND_CONFIRM_API_PATH: '/gateway-api/v1/private/fiatpayment/bind-confirm',
  BIND_SEND_OPT_API_PATH: '/gateway-api/v1/private/fiatpayment/bind-send-opt',
  GET_CHARGE_ADDRESS: '/gateway-api/v1/private/fiatpayment/get-charge-address',
  GET_CHARGE_ADDRESS_WITHOUT_LOGIN: '/gateway-api/v1/public/fiatpayment/get-configs',
  CHARGE_WITHDRAW_HISTORY: '/gateway-api/v1/private/fiatpayment/charge-withdraw-histroy',
  GET_QUOTE: '/gateway-api/v1/public/ocbs/get-quote',
  GET_CRYPRO_LIST: '/gateway-api/v1/public/fiat-channel-gateway/get-selector',

  // Authcenter apis
  USER_VERIFY_TOKEN: '/gateway-api/v1/public/authcenter/auth',
  USER_LOGIN_OUT_API: '/gateway-api/v1/private/authcenter/logout',
  LOGIN_API_PATH: '/gateway-api/v1/public/authcenter/login',
  CONFIRM_TIP: '/gateway-api/v1/private/account/user/confirm-tip',
  FORGET_PASSWORD_SEND_EMAIL: '/gateway-api/v1/public/account/user/forgot-password',
  RESET_PASSWORD: '/gateway-api/v1/public/account/user/reset-password',
  GET_LOGIN_QR_CODE: '/gateway-api/v1/public/qrcode/get',
  GET_LOGIN_QR_CODE_TITLE: '/gateway-api/v1/public/qrcode/config/qrcode.webtip',
  QUERY_LOGIN_QR_CODE: '/gateway-api/v1/public/qrcode/query',

  // User device apis
  DELETE_DEVICE_HISTORY: '/gateway-api/v1/private/account/user-device/delete',
  USER_DEVICES_LIST_API_PATH: '/gateway-api/v1/private/account/user-device/list',
  DEVICE_HISTORY: '/gateway-api/v1/private/account/user-device/log',

  // Asset apis
  GET_SYMBOL_BY_ASSET_API_PATH: '/gateway-api/v1/public/asset/symbols/get',
  USER_DIVIDENDS_API_PATH: '/gateway-api/v1/private/asset/asset/user-asset-dividend',
  GET_ASSET_INTO_API_PATH: '/gateway-api/v1/public/asset/asset/get',
  GET_ALL_ASSETS_API_PATH: '/gateway-api/v1/public/asset/asset/get-all-asset',
  GET_ALL_ASSETLOGO_API_PATH: '/gateway-api/v1/public/asset/asset/get-asset-logo',
  GET_WITHDRAW_ADDRESS_LIST:
    '/gateway-api/v1/private/asset/withdraw-address/get-withdraw-address-list',
  DELETE_WITHDRAW_ADDRESS: '/gateway-api/v1/private/asset/withdraw-address/delete-withdraw-address',
  SAVE_WITHDRAW_ADDRESS_API_PATH:
    '/gateway-api/v1/private/asset/withdraw-address/save-withdraw-address',
  ADD_TO_WHITELIST_API_PATH: '/gateway-api/v1/private/asset/withdraw-address/update-white-status',
  REMOVE_FROM_WHITELIST_API_PATH:
    '/gateway-api/v1/private/asset/withdraw-address/delete-white-withdraw-address',

  // market apis
  GET_NOTICE_API_PATH: '/gateway-api/v1/public/market/notice/get',
  RECOMMENDS_API_PATH: '/gateway-api/v1/public/market/recommend/get-asset',

  // notification apis
  GET_ABNORMAL_TRADE_NOTICE_LIST:
    '/gateway-api/v1/public/notification/trade-notice/get-abnormal-trade-notice-list',

  // dex testnet
  DEX_TESTNET_GET_ADDRESS: '/gateway-api/v1/private/dex-campaign/user-addresses',
  DEX_TESTNET_ADD_ADDRESS: '/gateway-api/v1/private/dex-campaign/add-addresses',
  DEX_USER_TRADING_INFO: '/gateway-api/v1/private/dex-campaign/user-campaign-account',
  DEX_TOP_YIELD_ACCOUNTS: '/gateway-api/v1/public/dex-campaign/top-yield-accounts',
  DEX_TOP_VOLUME_ACCOUNTS: '/gateway-api/v1/public/dex-campaign/top-volume-accounts',
  DEX_TOP_CAMPAIGN_ASSETS: '/gateway-api/v1/public/dex-campaign/campaign-assets',

  // Country apis
  CHECK_IP_API_PATH: '/gateway-api/v1/public/country/support/check/ip',
  GET_COUNTRY_WHITELIST: '/gateway-api/v1/public/country/list',
  CHECK_IP_ALLOW_ACCESS: '/gateway-api/v1/public/country/forbidden/check/ip',

  // Simplex apis
  GET_SIMPLEX_QUORE: '/gateway-api/v1/public/simplex/get-quote',
  GET_SIMPLEX_CURRENCY_LIST: '/gateway-api/v1/public/simplex/get-currency-list',
  SEND_PAYMENT_REQUEST: '/gateway-api/v1/private/simplex/send-payment-request',
  CHECK_SIMPLEX_STATUS: '/gateway-api/v1/public/simplex/get-status',
  CHECK_WHITE_LIST_USER: '/binance-api/v1/private/country/support/check/userId',

  // blog
  BLOG_LIST_API: '/gateway-api/v1/public/article/list/page',
  BLOG_DETAIL_API: '/gateway-api/v1/public/article/detail/get',
  BLOG_DETAIL_LOCALES_API: '/gateway-api/v1/public/article/language/support',

  // Api create apis
  GET_ALL_API: '/gateway-api/v1/private/api-mgmt/api/all',
  DEL_API: '/gateway-api/v1/private/api-mgmt/api/del',
  DEL_ALL_API: '/gateway-api/v1/private/api-mgmt/api/delall',
  SAVE_API: '/gateway-api/v1/private/api-mgmt/api/save',
  UPDATE_API: '/gateway-api/v1/private/api-mgmt/api/update',
  ENABLE_CREATE_API: '/gateway-api/v1/public/api-mgmt/api/enable-api-create',
  ENABLE_WITHDRAW: '/gateway-api/v1/public/api-mgmt/api/enable-api-withdraw',

  // Info apis
  ASSET_INFO_API: '/info-api/v1/public/get-info',

  // Margin apis
  MARGIN_ACCOUNT_ENABLE: `/${GATE_WAY}/v1/private/account/user/createMarginAccount`,
  MARGIN_ACCOUNT_DETAIL: `/${GATE_WAY}/v1/private/margin/account-details`,
  MARGIN_COEFF: `/${GATE_WAY}/v1/public/margin/coeff`,
  MARGIN_SYMBOLS: `/${GATE_WAY}/v1/public/margin/symbols`,
  MARGIN_TRANSFER_IN: `/${GATE_WAY}/v1/private/margin/transfer-in`,
  MARGIN_TRANSFER_OUT: `/${GATE_WAY}/v1/private/margin/transfer-out`,
  MARGIN_TRANSFER_OUT_AMOUT: `/${GATE_WAY}/v1/private/margin/max-transferable`,
  MARGIN_ALL_ASSET: `/${GATE_WAY}/v1/public/margin/asset/all`,
  MARGIN_BORROW_AMOUT: `/${GATE_WAY}/v1/private/margin/max-borrowable`,
  MARGIN_INTEREST_RATE: `/${GATE_WAY}/v1/public/margin/interest-rate`,
  MARGIN_BORROW: `/${GATE_WAY}/v1/private/margin/borrow`,
  MARGIN_REPAY: `/${GATE_WAY}/v1/private/margin/repay`,
  MARGIN_BORROW_HISTORY: `/${GATE_WAY}/v1/private/margin/borrow-history`,
  MARGIN_REPAY_HISTORY: `/${GATE_WAY}/v1/private/margin/repay-history`,
  MARGIN_TRANSFER_HISTORY: `/${GATE_WAY}/v1/private/margin/transfer-history`,
  MARGIN_INTEREST_HISTORY: `/${GATE_WAY}/v1/private/margin/interest-history`,
  MARGIN_CALL_HISTORY: `/${GATE_WAY}/v1/private/margin/notification-histories`,
  MARGIN_INTEREST_HISTORY_LIST: `/${GATE_WAY}/v1/private/interest-history/list`,
  MARGIN_ORDER_PLACE: `/${GATE_WAY}/v1/private/margin/place-order`,
  MARGIN_ORDER_DELETE_ORDER: `/${GATE_WAY}/v1/private/margin/cancel-order`,
  MARGIN_ORDER_DELETE_ALL: `/${GATE_WAY}/v1/private/margin/cancel-all-order`,
  MARGIN_PRICE_INDEX_HISTORY: `/${GATE_WAY}/v1/public/margin/price-index/history`,
  MARGIN_ALL_PRICE_INDEX: `/${GATE_WAY}/v1/public/margin/all-price-index`,

  // Referral apis
  COMMISSION_TOTAL_PATH: `/${GATE_WAY}/v1/private/account/commission/total`,
  COMMISSION_FIAT_TOTAL_PATH: `/${GATE_WAY}/v1/private/account/commission/fiatTotal`,
  COMMISSION_DETAIL_PATH: `/${GATE_WAY}/v1/private/account/commission/referral-bonus`,
  COMMISSION_TOP_PATH: `/${GATE_WAY}/v1/public/account/commission/top`,
  AGENT_DOWNLOAD_PATH: `/${GATE_WAY}/v1/private/account/agent/download`,
  COMMISSION_DOWNLOAD_PATH: `/${GATE_WAY}/v1/private/account/commission/download`,
  REFERRAL_MONTHLY: `/${GATE_WAY}/v1/private/asset-service/agent-reward/monthly-snapshots`,
  REFERRAL_FRIENDS: `/${GATE_WAY}/v1/private/account/user/referral-friends`,
  ACTIVITY_INFO: `/${GATE_WAY}/v1/public/marketing/referral/getActivityInfo`,
  MY_REFERRAL_REWARD_LIST: `/${GATE_WAY}/v1/private/marketing/referral/getMyReferralRewardInfo`,

  // coin apply
  COIN_APPLY_PATH: '/gateway-api/v1/private/market/asset/apply',

  // Small crypto to BNB
  DRIBBLET_BTC_PATH: '/exchange-api/v1/private/asset-service/asset/dribblet-btc',
  DRIBBLET_BNB_PATH: '/exchange-api/v1/private/asset-service/asset/dribblet-bnb',
  DRIBBLET_LOG_PATH: '/exchange-api/v1/private/asset-service/asset/dribblet-log',

  GATEWAY_CHANNEL: '/gateway-api/v1/public/common/config/fiat-gateway-channel',

  // Reset2fa
  PRE_VALIDATE: `/${GATE_WAY}/v1/protect/account-reset2fa/pre-validated`,
  FLOW_NEXT_STEP: `/${GATE_WAY}/v1/protect/account-reset2fa/flow-next-step`,
  GET_QUESTIONS: `/${GATE_WAY}/v1/protect/account-reset2fa/get-question`,
  ANSWER_QUESTION: `/${GATE_WAY}/v1/protect/account-reset2fa/answer-question`,
  FLOW_OPEN_EMAIL: `/${GATE_WAY}/v1/protect/account-reset2fa/flow-open-email`,

  // get asset min trade
  USER_MIN_TRADE_INFO_PAI_PATH: `/${GATE_WAY}/v1/public/asset-service/product/get-exchange-info`,

  // Support Center
  INSTANT_SEARCH_API: `/${GATE_WAY}/v1/public/zendesk/instant-search`,

  // Staking
  STAKING_LIST: `/${GATE_WAY}/v1/friendly/staking/list`,
  STAKING_DETAIL: `/${GATE_WAY}/v1/friendly/staking/detail`,
  STAKING_REBATE: `/${GATE_WAY}/v1/private/staking/rebate`,
  STAKING_HOLD_HISTORY: `/${GATE_WAY}/v1/private/staking/userSnapshot`,

  // inmail data api
  GET_IN_MAIL_DATA_API_PATH: `/${GATE_WAY}/v1/private/inbox/message-text/select`,
  GET_IN_MAIL_MODULS_API_PATH: `/${GATE_WAY}/v1/private/inbox/module/all/select`,
  SET_IN_MAIL_READ_DELET_API_PATH: `/${GATE_WAY}/v1/private/inbox/message-text/read_delete`,
  SET_IN_MAIL_UNREAD_API_PATH: `/${GATE_WAY}/v1/private/inbox/message-text/count/unread`,
  GET_IN_MAIL_STREAM_TOKEN_API_PATH: `/${GATE_WAY}/v1/private/inbox/user/token/get`,
};
